

interface IProps {
  defaultMemo: string;
  memo: string;
  isWritting: boolean;
  onChangeMemo: (e: React.SyntheticEvent<HTMLInputElement>) => void;
}

const SendInputMemo = ({ defaultMemo, memo, isWritting, onChangeMemo }: IProps) => {
  return (
    isWritting && (
      <div className="send-memo-group">
        <label htmlFor="send-memo" className="send-memo-label text-base font-medium">이 주소에 대한 메모</label>
        <input type="text" id="send-memo" name="send-memo" placeholder="메모 입력" className="send-memo-input text-base font-normal" value={memo} onChange={onChangeMemo} />
      </div>
    )
  );
};

export default SendInputMemo;
